import * as React from 'react'

import JobsiteHomepageContainerBase from '~/client/src/shared/components/JobsiteHomepageContainer/JobsiteHomepageContainerBase'
import {
  Content,
  Footer,
  Header,
  View,
} from '~/client/src/shared/components/Layout'

import BottomNavigationNavBar from '../BottomNavigationNavBar/BottomNavigationNavBar'

/**
 * Mobile JobsiteHomepageContainer - Includes BottomNavigationNavBar
 */
export default class JobsiteHomepageContainer extends React.Component {
  public render(): JSX.Element {
    return (
      <View className="jobsite-homepage-mobile">
        <div className="col relative overflow-auto">
          <Header>
            {/* Header can be empty or include header content if needed */}
          </Header>
          <Content scrollable={false}>
            <JobsiteHomepageContainerBase />
          </Content>
        </div>
        <Footer className="sticky logistics-footer">
          <BottomNavigationNavBar />
        </Footer>
      </View>
    )
  }
}
